module.exports = __webpack_public_path__ + "static/media/ug.f6dbcb21.svg";